import Vue from 'vue'
import VueRouter from 'vue-router'

import Default from '@/pages/default'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'default-view',
      component: Default
    }
  ]
})
